import SiteTrialContainer from "components/Site/Trial/SiteTrial.container";

const SiteTrialPage = () => {
  return <SiteTrialContainer />;
};

export default SiteTrialPage;
